export default __webpack_public_path__ + "static/media/expand-arrow.e8fdb03b.svg";